<template>
  <div class="opc-nav__back" v-if="hasHistory || this.backHandler">
    <zm-button type="link" data-testid="checkout-button-31" @click="back" :loading="loading">
      <zm-icon><ChevronLeftV2 /></zm-icon>
      {{ $t('common.btn_back') }}
    </zm-button>
  </div>
</template>

<script>
import { ChevronLeftV2 } from '@zoom/icons-vue';

export default {
  // Added: Register the ChevronLeftV2 component
  components: {
    ChevronLeftV2
  },
  props: {
    backHandler: {
      type: Function,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    hasHistory() {
      return window.history && window.history.length > 1;
    }
  },
  methods: {
    back() {
      this.backHandler ? this.backHandler() : window.history.back();
    },
  },
};
</script>

<style lang="scss">
$color: var(--zoom-color-text-strong-neutral, #555B62);
.opc-nav__back {
  width: 100%;
  text-align: left;
  // color: $color;
  display: flex;
  align-items: center;
  .zbo-button {

    &__label {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
</style>
